import React, { Component } from "react";
import { getStaticText } from '../../../lables/lablesService';
import Spinner from '../../../components/spinner-component/Spinner';
import Form from '../../../components/form-component/form';
import Table from '../../../components/table-data-component/table';
import InformationForTouristsCategories from '../api/categories';
import InformationForTouristsPosts from '../api/posts';
import Popup from "reactjs-popup";

import 'reactjs-popup/dist/index.css';
import '../../../scss/os-global.scss';


class InformationForTouristsRecordsPage extends Component {

    constructor(props) {
        super(props);

        this.DataService = InformationForTouristsPosts;
        this.categories = {};
        this.rows = [];
        this.page = 1;
        this.per_page = 10;
        this.all_pages = 0;
        this.order = {'id' : "DESC"};

        this.save_type_process = false;
        this.form_info = {};
        this.empty_form_info = {
            'id' : 0,
            'image' : '',
            'title' : '',
            'content' : '',
            'type_id' : 0,
            'active' : 1,
            'position' : 99999
        };

        this.state = {
            'has_data' : false,
            'show_popup' : false
        };
    }


    /*====================================================================================*/
    /*====================================================================================*/
    /*====================================================================================*/
    async changePage (page_number = 1) {
        this.page = page_number;
        await this.getDataList();
    }


    async changeOrder (new_order = {}) {
        this.order = new_order;
        await this.getDataList();
    }


    openAddNewForm () {
        this.form_info = {};
        Object.assign(
            this.form_info,
            this.empty_form_info
        );
        this.popupToggle();
    }


    openEditForm ( row_for_edit = {} ) {
        this.form_info = {};
        Object.assign(
            this.form_info,
            row_for_edit
        );
        this.popupToggle();
    }


    popupToggle () {
        this.setState({
            'show_popup' : !this.state.show_popup
        });
    }


    /*====================================================================================*/
    /*====================================================================================*/
    /*====================================================================================*/


    async saveCallback ( info_from_form = {} ) {
    	let saved = null;

    	if ( this.form_info.id ) {
    		saved = await this.DataService.update( info_from_form );
    	} else {
    		saved = await this.DataService.add( info_from_form );
    	}

    	if ( !saved ) {
            window.alert( getStaticText('save_error') );
        } else {
            window.alert( getStaticText('save_success') );
            this.page = 1;
	        this.popupToggle();
	        await this.getDataList();
        }
    }


    async deletePost ( post_for_delete ) {
        if ( !window.confirm(getStaticText('remove_confirm_text')) )
            return false;

        let result = await this.DataService.remove( post_for_delete.id );
        if ( !result ) {
            window.alert( getStaticText('remove_error') );
        } else {
            window.alert( getStaticText('remove_success') );
            this.page = 1;
            this.getDataList();
        }
    }


    async getDataList () {
        this.setState({'has_data' : false});

        let list_response = await this.DataService.list({
	                                                    'page' : this.page,
	                                                    'per_page' : this.per_page,
	                                                    'order' : this.order
	                                                });
        if ( typeof(list_response.rows) !== 'undefined' ) {
            this.rows = list_response.rows;
            this.all_pages = list_response.all_pages;
        }

        this.setState({'has_data' : true});
    }


    async componentDidMount () {
    	let categories_response = await InformationForTouristsCategories.list({
																    		'page' : 1,
																    		'per_page' : 0,
																    		'order' : {
																    			'id' : 'DESC'
																    		}
																    	});
    	if ( typeof(categories_response.rows) !== 'undefined' ) {
    		for ( let key in categories_response.rows ) {
    			this.categories[categories_response.rows[key].id] = categories_response.rows[key].name;
    		}
    	}

    	await this.getDataList();
    }


    render () {
        let content = null;
        if ( !this.state.has_data ) {
            content = (<div className="col-lg-12 text-center">{<Spinner />}</div>);
        } else {
         	content = (<>
                <div className="col-lg-12 os-text-right">
                    <button 
                        onClick={this.openAddNewForm.bind(this)}
                        className="btn btn-success text-white"
                    >
                        {getStaticText('iftr_add_new_button_label')}
                    </button>
                </div>

                <Popup
                    open={this.state.show_popup}
                    closeOnDocumentClick={false}
                    closeOnEscape={false}
                    className="os-popup"
                >
                    <>
                        <div className="os-popup-header">
                            <span className="op-popup-title">
                                {this.form_info.id ? getStaticText('iftr_edit_popup_title') : getStaticText('iftr_add_new_popup_title')}
                            </span>
                            <button
                                onClick={this.popupToggle.bind(this)}
                                className="os-popup-close-button"
                            >
                                <i className="fa fa-times" />
                            </button>
                        </div>

                        <div className="os-popup-body">
                            <Form
                                info={this.form_info}
                                sections={{
                                	'rtac_form' : {
                                		'fields' : {
                                			'image' : {
                                				'type' : 'input_image',
                                				'name' : 'image',
                                                'getDefaultValue' : (value) => {return typeof(value) === 'string' ? this.DataService.getImageUrl(value) : value;},
                                				'label' :  getStaticText('iftr_form_image_input_label')
                                			},
                                			'title' : {
                                				'type' : 'input_text',
                                				'name' : 'title',
                                				'label' :  getStaticText('iftr_form_title_input_label')
                                			},
                                			'type_id' : {
                                				'type' : 'input_select',
                                				'name' : 'type_id',
                                				'label' : getStaticText('iftr_form_type_id_input_label'),
                                				'options' : Object.assign({'0' : getStaticText('iftr_form_type_id_input_empty_row')}, this.categories)
                                			},
                                			'content' : {
                                				'type' : 'input_html',
                                				'name' : 'content',
                                				'label' :  getStaticText('iftr_form_description_input_label')
                                			},
                                            'position' : {
                                                'type' : 'input_text',
                                                'name' : 'position',
                                                'label' :  getStaticText('iftr_form_position_input_label')
                                            },
                                			'active' : {
                                				'type' : 'input_checkbox',
                                				'name' : 'active',
                                				'label' :  getStaticText('iftr_form_active_input_label')
                                			}
                                		}
                                	}
                                }}
                                formDataType="FormData"
                                buttonLabel={this.form_info.id ? getStaticText('iftr_form_update_button_label') : getStaticText('iftr_form_add_button_label')}
                                saveInfoCallback={this.saveCallback.bind(this)}
                            />
                        </div>
                    </>
                </Popup>

                <div className="col-lg-12 pt-3">
                    <Table 
                        currentOrder={this.order}
                        changeOrderCallback={this.changeOrder.bind(this)}
                        header={{
                            'id' : {
                                'label' : getStaticText('iftr_table_head_id_label'),
                                'sortButton' : true
                            },
                            'title' : {
                                'label' : getStaticText('iftr_table_head_name_label'),
                                'sortButton' : true
                            },
                            'type_id' : {
                            	'label' : getStaticText('iftr_table_head_category_label'),
                                'sortButton' : true
                            },
                            'active' : {
                                'label' : getStaticText('iftr_table_head_active_label'),
                                'sortButton' : true
                            },
                            'position' : {
                                'label' : getStaticText('iftr_table_head_position_label'),
                                'sortButton' : true
                            },
                            '-' : {
                                'label' : '',
                                'sortButton' : false
                            }
                        }}
                        body={[
                                (row)=>{return row.id;},
                                (row)=>{return row.title;},
                                (row)=>{return this.categories[row.type_id] || '';},
                                (row)=>{return row.active ? getStaticText('iftr_table_body_active_yes_label') : getStaticText('iftr_table_body_active_not_label'); },
                                (row)=>{return row.position;},
                                (row)=>{
                                    return (<>
                                        <button 
                                            className="btn btn-sm btn-info text-white os-mr-1"
                                            title={getStaticText('iftr_edit_button_title')}
                                            onClick={this.openEditForm.bind(this, row)}
                                        >
                                            <span className="fa fa-edit"></span>
                                        </button>
                                        <button 
                                            className="btn btn-sm btn-danger text-white"
                                            title={getStaticText('iftr_delete_button_title')}
                                            onClick={this.deletePost.bind(this, row)}
                                        >
                                            <span className="fa fa-trash"></span>
                                        </button>
                                    </>);
                                }
                            ]}
                        rows={this.rows}
                        emptyRowsMessage={getStaticText('rtac_table_empty_list_message')}
                        page={this.page}
                        allPages={this.all_pages}
                        changePageCallback={this.changePage.bind(this)}
                    />
                </div>                

            </>);
        }
        return (<div className="row">
                    <div className="col-lg-12">
                        <h2>{getStaticText('iftr_section_title')}</h2>
                    </div>
                    {content}
                </div>);
    }

}


export default InformationForTouristsRecordsPage;